export default [

     {
          path: '/third-party-profile-contact',
          name: 'ThirdPartyProfileContact',
          component: () => import("@/views/Page/ThirdPartyProfileContact/ThirdPartyProfileContact.vue"),
           meta: {
               title: 'GRC | ThirdPartyProfileContact',
          },
     }
];